import {useQuery} from 'react-query';
import {calculateCashBackRestCredits} from '../../helpers/cashBackAmountAmountHelpers';
import {CashBackStatus, ICashBackCard} from './cashBackCards.types';
import {getCashBackCards} from './getCashBackCards';

const useGetCashBackCards = (enabled?: boolean) => {
  const query = useQuery(
    ['get-cash-back-cards-list'],
    () => getCashBackCards(),
    {enabled: enabled ?? true},
  );

  const currentCashBacks: ICashBackCard[] = [];
  const paidCashBacks: ICashBackCard[] = [];

  let totalCashBackActiveCredit = 0;

  query.data?.forEach(card => {
    if (
      card?.status === CashBackStatus.Paid ||
      card?.status === CashBackStatus.Consumed
    ) {
      paidCashBacks.push(card);
    } else {
      currentCashBacks.push(card);
    }

    if (card?.status === CashBackStatus.Active) {
      totalCashBackActiveCredit += calculateCashBackRestCredits(
        card?.amount,
        card?.used_amount,
        card?.reserved_amount,
      );
    }
  });

  return {
    ...query,
    currentCashBacks,
    paidCashBacks,
    totalCashBackActiveCredit,
  };
};

export default useGetCashBackCards;
